import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';
import Helper from '@/resources/Helper';

const tableName = 'store';

const functions = {
    async get() {
        await this.sync();
        
        return await DBEngine.getContentObject(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncStoreVersion(tableName);
    },
    async save(content) {
        const currentData = await this.get();
        let saveData = null;

        if (currentData) {
            saveData = currentData.content;
        }

        saveData[content.group] = content.value;
        saveData[content.group].timestamp = Helper.getClientTime();

        // Setup Current IndexedDB
        DBEngine.replaceRecord(tableName, saveData, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, 'update', content);
    }
}

export default functions;